import _defineProperty from "/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { filterDOMProps as $e3Dei$filterDOMProps, clamp as $e3Dei$clamp, mergeProps as $e3Dei$mergeProps } from "@react-aria/utils";
import { useLabel as $e3Dei$useLabel } from "@react-aria/label";
import { useNumberFormatter as $e3Dei$useNumberFormatter } from "@react-aria/i18n";
function $204d9ebcedfb8806$export$ed5abd763a836edc(props) {
  var _props$value = props.value,
    value = _props$value === void 0 ? 0 : _props$value,
    _props$minValue = props.minValue,
    minValue = _props$minValue === void 0 ? 0 : _props$minValue,
    _props$maxValue = props.maxValue,
    maxValue = _props$maxValue === void 0 ? 100 : _props$maxValue,
    valueLabel = props.valueLabel,
    isIndeterminate = props.isIndeterminate,
    _props$formatOptions = props.formatOptions,
    formatOptions = _props$formatOptions === void 0 ? {
      style: 'percent'
    } : _props$formatOptions;
  var domProps = $e3Dei$filterDOMProps(props, {
    labelable: true
  });
  var _$e3Dei$useLabel = $e3Dei$useLabel(_objectSpread(_objectSpread({}, props), {}, {
      // Progress bar is not an HTML input element so it
      // shouldn't be labeled by a <label> element.
      labelElementType: 'span'
    })),
    labelProps = _$e3Dei$useLabel.labelProps,
    fieldProps = _$e3Dei$useLabel.fieldProps;
  value = $e3Dei$clamp(value, minValue, maxValue);
  var percentage = (value - minValue) / (maxValue - minValue);
  var formatter = $e3Dei$useNumberFormatter(formatOptions);
  if (!isIndeterminate && !valueLabel) {
    var valueToFormat = formatOptions.style === 'percent' ? percentage : value;
    valueLabel = formatter.format(valueToFormat);
  }
  return {
    progressBarProps: $e3Dei$mergeProps(domProps, _objectSpread(_objectSpread({}, fieldProps), {}, {
      'aria-valuenow': isIndeterminate ? undefined : value,
      'aria-valuemin': minValue,
      'aria-valuemax': maxValue,
      'aria-valuetext': isIndeterminate ? undefined : valueLabel,
      role: 'progressbar'
    })),
    labelProps: labelProps
  };
}
export { $204d9ebcedfb8806$export$ed5abd763a836edc as useProgressBar };